export enum ChartType {
  Bar = 'bar_chart',
  Value = 'value',
}
